import {InjectionToken} from '@angular/core';
import {FrontOrigin} from '../domain/enum/frontOrigin';

export const FRONT_ORIGIN = new InjectionToken<FrontOrigin>('Front origin sending a http request');
